import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { 
  ErrorMessage,
  Field, 
  Form, 
  Formik 
} from 'formik';
import {
  Button,
  FormGroup,
  Modal,
  ModalHeader,
  ModalBody,
  Label
} from 'reactstrap';
import { addComment } from './commentsSlice';
import { validateCommentForm } from '../../utils/validateCommentForm';

const CommentForm = ({ campsiteId }) => {

  const [modalOpen, setModalOpen] = useState(false);

  const dispatch = useDispatch();

  const handleSubmit = (values) => {
    const comment = {
      id: values.id,
      campsiteId: parseInt(campsiteId),
      rating: parseInt(values.rating),
      text: values.commentText,
      author: values.author,
      date: new Date(Date.now()).toISOString()
    };
    console.log(comment);
    dispatch(addComment(comment));
    setModalOpen (false);
  }

  return (
    <>
      <Button outline onClick={() => setModalOpen(true)} >
      <i className='fa fa-pencil fa-lg' /> Add Comment
      </Button>
      <Modal isOpen={modalOpen}>
        <ModalHeader toggle={() => setModalOpen(false)}>
          Add Comment
        </ModalHeader>
        <ModalBody>
          <Formik
            initialValues={{
              rating: undefined,
              author: '',
              commentText: ''
            }}
            onSubmit={handleSubmit}
            validate={validateCommentForm}
          >
            <Form>
              <FormGroup> {/* #1 START */}
                <Label htmlFor='rating'>
                  Rating
                </Label>
                <Field
                  name='rating'
                  as='select'
                  className='form-control'
                >
                  <option>Select...</option>
                  <option>1</option>
                  <option>2</option>
                  <option>3</option>
                  <option>4</option>
                  <option>5</option>
                </Field>
                <ErrorMessage name='rating'>
                  {(msg) => <p className='text-danger'>{msg}</p>}
                </ErrorMessage>
              </FormGroup> {/* #1 END */}
              <FormGroup>  {/* #2 START */}
                <Label htmlFor='author'>
                  Your Name
                </Label>
                <Field
                  name='author'
                  placeholder='Your Name'
                  className='form-control'
                />
                <ErrorMessage name='author'>
                  {(msg) => <p className='text-danger'>{msg}</p>}
                </ErrorMessage>
              </FormGroup> {/* #2 END */}
              <FormGroup>  {/* #3 START */}
                <Label htmlFor='commentText'>
                  Comment
                </Label>
                <Field
                  name='commentText'
                  as='textarea'
                  rows='12'
                  className='form-control'
                />
              </FormGroup> {/* #3 END */}
              <Button type='submit' color='primary'>
                Submit
              </Button>
            </Form>
          </Formik>
        </ModalBody>
      </Modal>
    </>
  );
};

export default CommentForm;